export const environment = {
  LOG_LEVEL: 'warn' as loglevel,
  CURRENT_URL: `${window.location.protocol}//${window.location.host}`,
  ANGULAR_ENV: 'production' as nodenv,
  API_BASE: 'https://greenenergyfundapp.com/api/v1',
  SENTRY_DSN:
    'https://30b187bd564f52e4289208b7059abc12@o4506355567689728.ingest.us.sentry.io/4509315722838016',
  NETWORK_DELAY: 0,
}
